module.exports = __webpack_public_path__ + "img/uo_power_icon-1.e13e81e6.svg";